export default __webpack_public_path__ + "static/media/2.caadad83.jpg";